/* eslint-disable */

import axios from 'axios'

import router from '@/router/router'
import jwt_decode from 'jwt-decode'

const clearState = (context) => {
  context.commit('clearJsonWebTokenState');
}

const setToken = (context, token) => {
  context.commit('updateToken', token);
}

const refreshToken = async (context) => {
  const headers = {
    headers: {
      'Content-Type': 'application/json',
    }
  }

  const payload = JSON.stringify({
    token: context.state.jwt
  })
  
  await axios.post(context.state.endpoints.refreshJWT, payload, headers)
    .then((response)=>{
        context.commit('updateToken', response.data.token);
      })
    .catch((error)=>{
        console.log(error);
      })
}

const inspectToken = async (context) => {
  const token = context.state.jwt;
  if (token) {
    const decoded = jwt_decode(token);
    const exp = decoded.exp;
    const orig_iat = decoded.orig_iat;
    if (exp - (Date.now()/1000) > 0 && exp - (Date.now()/1000) < 82800 && (Date.now()/1000) - orig_iat < 604800) {
      await context.dispatch('refreshToken');
    } else if ((Date.now()/1000) - orig_iat > 604800 || exp - (Date.now()/1000) < 0) {
      context.dispatch('clearState');
      router.push('/login');         
    } else {
      // Good Token
    }
  } else {
    router.push('/login');
  }
}

export default {
  clearState,
  setToken,
  refreshToken,
  inspectToken,
}